import { GraphDefinition } from '../../coaching-insight/line-area.component';
import { MetricDataItem } from '../../performance-data/metric.pd.model';
import { PeriodType } from '../../widget/date-range.widget.model';

import { ChartType } from './chart-type.model';

export interface PillarThreeState {
    pending: {
        reloadChart?: boolean;
        reloadDetail?: boolean;
    };
    userId?: number;
    chartType: ChartType;
    periodTypeId: PeriodType;
    metricId?: number;
    commitmentId?: number;
    graphSet?: GraphDefinition[];
    dates?: Array<{ startDate: Date; endDate: Date }>;
    periodPerf?: MetricDataItem[];
}

export const defaultState = (): PillarThreeState => ({
    pending: {},
    chartType: ChartType.TREND,
    periodTypeId: PeriodType.ROLLING_30,
});
